var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _vm._v("\n  消息推送记录\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }